import React from 'react';
import PandaLoader from './PandaLoader';

const LoadingScreen = ({
  message = 'Loading...',
  // eslint-disable-next-line no-unused-vars
  type = 'default',
  // eslint-disable-next-line no-unused-vars
  fullScreen = false,
  subMessage,
}) => {
  return (
    <PandaLoader
      variant="fullscreen"
      message={message}
      subMessage={subMessage}
    />
  );
};

export default LoadingScreen;
